import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Tenants',
  to: {
    name: 'tenants',
    query: {
      pageNum: '1',
    },
  },
};

export default {
  path: '/tenants',
  component: Wrapper,
  children: [
    {
      path: '',
      name: 'tenants',
      component: () => import(/* webpackChunkName: "tenants" */ './_views/UmsTenants'),
      meta: {
        title: 'Tenants',
        navigation: {
          position: 4,
          name: 'Tenants',
          icon: 'work',
          to: {
            name: 'tenants',
            query: {
              pageNum: '1',
            },
          },
        },
      },
    },
    {
      path: 'history/:tenant',
      name: 'tenantHistory',
      component: () => import(/* webpackChunkName: "tenantHistory" */ './_views/UmsTenantHistory'),
      meta: {
        title: 'Tenant history',
        parent: parentRouteConfig,
        customDisplayedParamKey: 'tenant',
      },
    },
  ],
};
